import React from 'react';
import { CampusResourcesQuery, ResourceType } from '../../../graphQL';
import {
  CAMPUS_RESOURCE_METADATA,
  CURRENT_CAMPUS_RESOURCE_TYPES,
  isCurrentCampusResource,
} from '../constants/campusResourceMetadata';
import { ResourceSection } from './ResourceSection';

type Props = {
  organizationId: number;
  editable?: boolean;
  verticalDisplay?: boolean;
  resources: CampusResourcesQuery['organization']['resources'];
  refetch: () => Promise<unknown>;
};

export function CampusResourcesSection({
  organizationId,
  editable,
  verticalDisplay,
  resources,
  refetch,
}: Props) {
  type Resource = CampusResourcesQuery['organization']['resources'][number];

  const createOtherSection = (allResources: Resource[]) => ({
    label: CAMPUS_RESOURCE_METADATA[ResourceType.Other]?.title || ResourceType.Other,
    info: CAMPUS_RESOURCE_METADATA[ResourceType.Other]?.description,
    category: ResourceType.Other,
    resources: allResources.filter(
      ({ resourceType }) =>
        // Include Other type or legacy types that are not in CURRENT_CAMPUS_RESOURCE_METADATA
        resourceType === ResourceType.Other || !isCurrentCampusResource(resourceType)
    ),
  });

  return (
    <ResourceSection
      organizationId={organizationId}
      editable={editable}
      verticalDisplay={true}
      resources={resources}
      refetch={refetch}
      metadata={CAMPUS_RESOURCE_METADATA}
      resourceTypes={CURRENT_CAMPUS_RESOURCE_TYPES.filter(type => type !== ResourceType.Other)}
      sectionKeyPrefix="campus"
      resourceValidator={isCurrentCampusResource}
      createOtherSection={createOtherSection}
    />
  );
}
